<script lang="ts">
	import { FoodResultType, type TagsFoodResultPayload } from "$lib/def/landing";

	import { KEY_VERTICAL } from "$lib/def/verticals";
	import { KEY_SEARCH_VERTICAL } from "$lib/serv/food-landing";
	import { slugify } from "$lib/util/format";
	import { queryFrom } from "$lib/util/url";
	import { KEY_SEARCH_FOUND } from "../../FoodLanding.svelte";
	import { DIVIDER } from "../menu/server";
	
	import Grid from "$lib/ui/layout/Grid.svelte";
	import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";

	export let payload: TagsFoodResultPayload;
	export let recommended = false;
	export let searchParams: Record<string, string>;

	$: vert = searchParams[KEY_SEARCH_VERTICAL] || searchParams[KEY_VERTICAL];

</script>

<div class="headline-m bold">{payload.name}</div>

{#if recommended}
	<Grid cache={{payload}} type="filters" key={p => p?.items} let:item>
		<!-- setting the landing items vertical is crucial - if the incorrect value is passed the wrong list of entities will be loaded which the quick pick on -->
		<a href={queryFrom(searchParams).set(KEY_VERTICAL, vert).set(KEY_SEARCH_FOUND, FoodResultType.RecommendedTag + DIVIDER + slugify(item.name)).toUrl()} class="item">
			<LazyBackgroundImage image={item.image_url} alt={item.name} />
			<div class="label-xl medium">{item.name}</div>
		</a>
	</Grid>
{:else}
	<div class="pills">
		{#each payload.items as item}
			<!-- setting the landing items vertical is crucial - if the incorrect value is passed the wrong list of entities will be loaded which the quick pick on -->
			<a href={queryFrom(searchParams).set(KEY_VERTICAL, vert).set(KEY_SEARCH_FOUND, FoodResultType.Tag + DIVIDER + slugify(item.name)).toUrl()} class="label-xl book">
				{item.name}
        <span style="margin-left: 4px;" class="icon-chevron-right-20"></span>
			</a>
		{/each}
	</div>
{/if}
